import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/install";
import "@/lib/aiPackToast";

// Sign-in cookies only work on the API's own domain, so send visitors on other hosts (www, *.emergent.host) there
const canonical = new URL(process.env.REACT_APP_BACKEND_URL).origin;
if (window.location.origin !== canonical) {
  const { pathname, search, hash } = window.location;
  window.location.replace(canonical + pathname + search + hash);
}

registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
